// extracted by mini-css-extract-plugin
export default {"spinnerOverrides":"LoadingSpinner_spinnerOverrides__w1mGx"};